<template>
  <div
    class="window-item window-item_common"
    :class="[isCalled ? 'animation_is-called' : '', $store.infoscreenData.ticketCallAnimation]"
    :style="{ backgroundColor: $store.infoscreenData.infoboardBackgroundColor }"
  >
    <p
      ref="windowNumber"
      class="window-number"
      :style="{
        fontSize: windowNumberFontSize + 'vw',
        color: $store.infoscreenData.infoboardWindowColor,
        fontFamily: `${$store.infoscreenData.fontBoldFamily}, ${$store.fontFamilyDefault}, sans-serif`
      }"
    >
      {{ WINDOW_TYPE_TRANSLATIONS[ticket.window.type] | translate }} {{ ticket.window.number }}
    </p>

    <div class="window-info">
      <TicketIcon
        v-if="$store.deviceStartData.are_arrows_enabled"
        class="icon"
        :icon="ticket.window.arrow"
        :color="$store.infoscreenData.infoboardWindowColor"
      />
      <p
        class="window-id"
        :style="{
          color: $store.infoscreenData.infoboardTicketNumberColor,
          fontFamily: `${$store.infoscreenData.fontBoldFamily}, ${$store.fontFamilyDefault}, sans-serif`
        }"
      >
        {{ ticket.prefix }}{{ ticket.number }}
      </p>
    </div>
  </div>
</template>

<script>
import TicketMixin from '../../mixins/TicketMixin';

export default {
  name: 'TicketCommon',
  mixins: [TicketMixin],
  data() {
    return {
      defaultWindowNumberFontSize: 2.91666667,
      windowNumberFontSize: 2.91666667
    }
  }
}
</script>

<style lang="scss" scoped>
.window-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding: 0 1.04166667vw;

  .window-info {
    margin-top: 0.3125vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .window-number {
    white-space: nowrap;
    font-size: 2.91666667vw;
    font-weight: 600;
  }

  .window-id {
    font-size: 5vw;
    font-weight: 600;
  }
}

.icon {
  width: 5vw;
  height: 5vw;
  display: block;
}
</style>
